import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Hero = () => {
  const [videoUrl, setVideoUrl] = useState(null);

  // 🔹 Fetch hero video from backend
  useEffect(() => {
    const fetchHeroVideo = async () => {
      try {
        const API = process.env.REACT_APP_BACKEND_URL || '';
        const response = await axios.get(`${API}/api/videos`);

        const heroVideo = response.data.find(
          (video) => video.type === 'hero' && video.isActive
        );

        if (heroVideo?.url) {
          setVideoUrl(heroVideo.url);
        }
      } catch (error) {
        console.error('Failed to fetch hero video:', error);
      }
    };

    fetchHeroVideo();
  }, []);

  return (
    <div
      id="hero"
      className="relative aspect-[3/4] md:aspect-auto md:h-[85vh] overflow-hidden"
    >
      {/* 🖼 HERO POSTER – LCP ELEMENT */}
      <img
        src="/hero-poster-mobile.webp"
        srcSet="
          /hero-poster-mobile.webp 768w,
          /hero-poster.webp 1920w
        "
        sizes="(max-width: 768px) 100vw, 100vw"
        alt="Bungee Jumping Experience at Indya Bungy"
        className="absolute inset-0 w-full h-full object-cover z-0"
        fetchpriority="high"
        loading="eager"
        width="768"
        height="900"
      />

     <video
       key={videoUrl}
       autoPlay
       loop
       muted
       playsInline
       preload="none"
       poster="/hero-poster-mobile.webp"
       className="absolute inset-0 w-full h-full object-cover z-10"
       >
  <source src={videoUrl} type="video/mp4" />
</video>
      {/* 🌑 Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30 z-20"></div>

      {/* 📝 HERO CONTENT */}
      <div className="relative z-30 h-full flex flex-col items-center justify-center px-4 text-center">
        <div className="space-y-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white tracking-tighter">
            JUMP. SCREAM.
          </h1>
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-200 tracking-tighter">
            BUNGEEEE...
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Hero;
